import bus from "@/utils/bus"
import request from '@/utils/apiRequest'

let permissionCodeList = null
// 缓存
let hasPermissionCache = {}
bus.$on("onLoginSuccess", () => {
  reset()
  request({
    url: '/user/sysGroup/getCanFunctionCode',
  }).then(res => {
    permissionCodeList = res.data
    localStorage.setItem("USER_MENU", JSON.stringify(permissionCodeList))
  })
})
bus.$on("onLogout", () => {
  reset()
})

function reset() {
  hasPermissionCache = {}
  localStorage.removeItem("USER_MENU")
}

function getPermissionCodeList() {
  if (permissionCodeList == null) {
    permissionCodeList = JSON.parse(localStorage.getItem("USER_MENU"))
  }
  return permissionCodeList;
}

export const hasPermission = function(permissionId) {
  permissionId = '' + permissionId
  if (hasPermissionCache[permissionId] != null) {
    return hasPermissionCache[permissionId]
  }
  hasPermissionCache[permissionId] = getPermissionCodeList().includes(permissionId)
  return hasPermissionCache[permissionId]
}

/**
 * 全局权限控制
 */
export const filterGlobalPermission = (el, binding, vnode) => {
  if (binding.value == null || binding.value == '') {
    return;
  }
  if (!hasPermission(binding.value)) {
    el.parentNode.removeChild(el);
  }
}

const hasPermissionDirective = {
  install (Vue, options) {
    Vue.directive('has', {
      inserted: (el, binding, vnode)=>{
        filterGlobalPermission(el, binding, vnode);
      }
    });
  }
};

export default hasPermissionDirective;
